import { Link } from "react-router-dom";
import styled, { css } from "styled-components/macro";

type TFooterMobileThemeProps = {
  $isDarkTheme?: boolean;
}

export const FooterWrapper = styled.footer<TFooterMobileThemeProps>`
  width: 100%;
  padding: 40px 26px;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(255, 255, 255, 0.14)" : "#000"};
  background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#07060A" : "#eeeff0"};
`;

export const Container = styled.div<TFooterMobileThemeProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#07060A" : "#eeeff0"};
`;

export const Logo = styled.img`
  display: block;
  width: 100%;
  margin-bottom: 38px;
`;

export const BlockSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-bottom: 10px;
`

export const SectionTitle = styled.span<TFooterMobileThemeProps>`
  display: block;
  font-weight: 400;
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#A7A7A7"};
  line-height: 22px;
  margin-bottom: 14px;
  text-align: left;
  width: 100%;
`;

export const ButtonContainer = styled.div<TFooterMobileThemeProps>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 36px;

  ${({ $isDarkTheme }) => $isDarkTheme
    ? css`
      a:hover {
        background-color: #BFDCF5;
        color: #141414;
        border-color: #BFDCF5;
      }
    `
    : ""};
    
  @media (max-width: 576px) {
    width: 100%;  
  }
`

export const Copyright = styled(SectionTitle)`
  margin-bottom: 0;
  text-align: center;
`;

export const StyledLink = styled(Link)<TFooterMobileThemeProps>`
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  text-decoration: none;
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "black"};

  &:last-child {
    margin-top: auto;
    margin-bottom: 14px;
  }
  
  &:hover {
    color: #1983ff;
  }
`;

export const SocialLink = styled.a<TFooterMobileThemeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#141414"};
  text-decoration: none;
  transition: color 0.2s ease;

  svg {
    display: block;
    width: auto;
    height: 40px;
  }

  svg path {
    fill: currentColor;
    transition: fill 0.2s ease;
  }

  &:hover {
    color: #1983ff;
  }
`;

export const LegalInfo = styled(SectionTitle)`
  margin-bottom: 24px;
  text-align: left;
  opacity: ${({ $isDarkTheme }) => $isDarkTheme ? 0.6 : 1};
`

export const Contacts = styled.div<TFooterMobileThemeProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 26px;
  margin-top: 12px;
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#141414"};
`

export const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 40px;
  margin-bottom: 14px;
`;
